import { render, staticRenderFns } from "./similaritySearch.vue?vue&type=template&id=7ffd6a6f&scoped=true&"
import script from "./similaritySearch.vue?vue&type=script&lang=js&"
export * from "./similaritySearch.vue?vue&type=script&lang=js&"
import style0 from "./similaritySearch.vue?vue&type=style&index=0&id=7ffd6a6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd6a6f",
  null
  
)

export default component.exports